
import { Component } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class GrubtechForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get items() {
    return [
      {
        name: 'enabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.grubtech.enabled',
      },
      {
        name: 'storeId',
        type: InputType.Text,
        label: 'venue.form.grubtech.storeId',
        autocomplete: 'off',
      },
      { name: 'apiKey', type: InputType.Text, label: 'venue.form.grubtech.apiKey', autocomplete: 'off' },
      {
        name: 'partnerId',
        type: InputType.Text,
        label: 'venue.form.grubtech.partnerId',
        autocomplete: 'off',
      },
    ];
  }

  public getData() {
    return {
      grubtech: { ...this.$refs.form.form },
    };
  }
}
